var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileApp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 78.9 158.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-3,.cls-4,.cls-5{fill:#267bfa;}.cls-3,.cls-5{stroke-width:2px;}.cls-3,.cls-5,.cls-2{stroke:#fff;stroke-miterlimit:10;}.cls-6{opacity:.15;}.cls-5{opacity:.25;stroke-linecap:round;}.cls-7{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "overlay",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m75,11.17v135.89c0,3.78-3.12,6.85-6.97,6.85H11.94c-3.85,0-6.97-3.07-6.97-6.85V11.17c0-3.78,3.12-6.85,6.97-6.85h6.98c.79,0,1.43.63,1.43,1.41,0,1.08.44,2.05,1.16,2.75.72.7,1.71,1.14,2.8,1.14h31.34c2.19,0,3.96-1.74,3.96-3.89,0-.39.16-.74.42-.99.26-.26.62-.41,1.01-.41h6.98c3.85,0,6.97,3.07,6.97,6.85Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.25,157.24c-5.62,0-10.18-4.55-10.18-10.14V11.14C2.07,5.55,6.64,1,12.25,1h55.47c5.62,0,10.18,4.55,10.18,10.14v135.96c0,5.59-4.57,10.14-10.18,10.14H12.25ZM12,3.83c-4.12,0-7.47,3.3-7.47,7.35v135.89c0,4.05,3.35,7.35,7.47,7.35h56.1c4.12,0,7.47-3.3,7.47-7.35V11.18c0-4.05-3.35-7.35-7.47-7.35h-6.98c-.52,0-1,.2-1.36.56-.37.36-.57.84-.57,1.35,0,1.87-1.55,3.39-3.46,3.39h-31.34c-.93,0-1.8-.35-2.45-1-.65-.64-1.01-1.49-1.01-2.4,0-1.05-.87-1.91-1.93-1.91h-6.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m67.72,1.5c5.34,0,9.68,4.32,9.68,9.64v135.96c0,5.32-4.34,9.64-9.68,9.64H12.25c-5.34,0-9.68-4.32-9.68-9.64V11.14C2.57,5.82,6.91,1.5,12.25,1.5h55.47m-43.34,7.13c-.79,0-1.54-.3-2.1-.85-.56-.55-.86-1.27-.86-2.04,0-1.33-1.09-2.41-2.43-2.41h-6.98c-4.39,0-7.97,3.52-7.97,7.85v135.89c0,4.33,3.58,7.85,7.97,7.85h56.1c4.39,0,7.97-3.52,7.97-7.85V11.17c0-4.33-3.58-7.85-7.97-7.85h-6.98c-.65,0-1.26.25-1.71.7-.46.45-.72,1.06-.72,1.71,0,1.6-1.33,2.89-2.96,2.89h-31.34M67.72.5H12.25C6.35.5,1.57,5.26,1.57,11.14v135.96c0,5.88,4.78,10.64,10.68,10.64h55.47c5.9,0,10.68-4.76,10.68-10.64V11.14c0-5.88-4.78-10.64-10.68-10.64h0ZM24.37,9.63h31.34c2.19,0,3.96-1.74,3.96-3.89,0-.39.16-.74.42-.99.26-.26.62-.41,1.01-.41h6.98c3.85,0,6.97,3.07,6.97,6.85v135.89c0,3.78-3.12,6.85-6.97,6.85H12c-3.85,0-6.97-3.07-6.97-6.85V11.17c0-3.78,3.12-6.85,6.97-6.85h6.98c.79,0,1.43.63,1.43,1.41,0,1.08.44,2.05,1.16,2.75.72.7,1.71,1.14,2.8,1.14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m43.73,5.39h-7.54c-.19,0-.34-.15-.34-.34s.15-.34.34-.34h7.54c.19,0,.34.15.34.34s-.15.34-.34.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m43.73,4.71h-7.54c-.19,0-.34.15-.34.34s.15.34.34.34h7.54c.19,0,.34-.15.34-.34s-.15-.34-.34-.34h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 49.02,
    cy: 5.05,
    r: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m49.02,4.15c-.5,0-.9.4-.9.9s.4.9.9.9.9-.4.9-.9-.4-.9-.9-.9h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m75,11.17v135.89c0,3.78-3.12,6.85-6.97,6.85H11.94c-3.85,0-6.97-3.07-6.97-6.85V11.17c0-3.78,3.12-6.85,6.97-6.85h6.98c.79,0,1.43.63,1.43,1.41,0,1.08.44,2.05,1.16,2.75.72.7,1.71,1.14,2.8,1.14h31.34c2.19,0,3.96-1.74,3.96-3.89,0-.39.16-.74.42-.99.26-.26.62-.41,1.01-.41h6.98c3.85,0,6.97,3.07,6.97,6.85Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1,
    y1: 20.05,
    x2: 1,
    y2: 25.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1,
    y1: 32.58,
    x2: 1,
    y2: 44.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1,
    y1: 46.99,
    x2: 1,
    y2: 58.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 29.86,
    y1: 151.26,
    x2: 50.11,
    y2: 151.26
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.14,
    y: 24.88,
    width: 15.41,
    height: 15.41,
    rx: 3.71,
    ry: 3.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 31.83,
    y: 24.88,
    width: 15.41,
    height: 15.41,
    rx: 3.71,
    ry: 3.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 53.53,
    y: 24.88,
    width: 15.41,
    height: 15.41,
    rx: 3.71,
    ry: 3.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.14,
    y: 46.57,
    width: 15.41,
    height: 15.41,
    rx: 3.71,
    ry: 3.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 31.83,
    y: 46.57,
    width: 15.41,
    height: 15.41,
    rx: 3.71,
    ry: 3.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 53.53,
    y: 46.57,
    width: 15.41,
    height: 15.41,
    rx: 3.71,
    ry: 3.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.14,
    y: 68.27,
    width: 15.41,
    height: 15.41,
    rx: 3.71,
    ry: 3.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 31.83,
    y: 68.27,
    width: 15.41,
    height: 15.41,
    rx: 3.71,
    ry: 3.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 53.53,
    y: 68.27,
    width: 15.41,
    height: 15.41,
    rx: 3.71,
    ry: 3.71
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileApp);
export default __webpack_public_path__ + "static/media/mobileApp.573e7c389c8588e0e077188c8a3ce0b9.svg";
export { ForwardRef as ReactComponent };